export const disableScroll = () => {
  document.body.classList.add("no-scroll");
};

export const enableScroll = () => {
  document.body.classList.remove("no-scroll");
};
